import BoomCard from './BoomCard';
import ValueCard from './ValueCard';
import BaseCard from './BaseCard';
import ZapCard from './ZapCard';
import BaseCardBehavior from '../../../State/Card/CardBehavior/BaseCardBehavior';
import ZapCardBehavior from '../../../State/Card/CardBehavior/ZapCardBehavior';
import BoomCardBehavior from '../../../State/Card/CardBehavior/BoomCardBehavior';
import ValueCardBehavior from '../../../State/Card/CardBehavior/ValueCardBehavior';
import PlusThreeCard from './PlusThreeCard';
import PlusThreeCardBehavior from '../../../State/Card/CardBehavior/PlusThreeCardBehavior';
import LockCardBehavior from '../../../State/Card/CardBehavior/LockCardBehavior';
import KeyCardBehavior from '../../../State/Card/CardBehavior/KeyCardBehavior';
import LockCard from './LockCard';
import KeyCard from './KeyCard';
import CardModifier from './Modifier/CardModifier';
import BaseModifierBehavior from '../../../State/Card/ModifierBehavior/BaseModifierBehavior';
import BombModifier from './Modifier/Bomb';
import RisingModifier from './Modifier/Rising';
import BombModifierBehavior from '../../../State/Card/ModifierBehavior/BombModifierBehavior';
import RisingModifierBehavior from '../../../State/Card/ModifierBehavior/RisingModifierBehavior';
import LoweringModifierBehavior from '../../../State/Card/ModifierBehavior/LoweringModifierBehavior';
import LoweringModifier from './Modifier/Lowering';
import IceModifier from './Modifier/Ice';
import IceModifierBehavior from '../../../State/Card/ModifierBehavior/IceModifierBehavior';
import AnchorCard from './AnchorCard';
import AnchorCardBehavior from '../../../State/Card/CardBehavior/AnchorCardBehavior';
import WaterModifierBehavior from '../../../State/Card/ModifierBehavior/WaterModifierBehavior';
import WaterModifier from './Modifier/Water';
import CrabCard from './CrabCard';
import AlgaeModifier from './Modifier/Algae';
import AlgaeModifierBehavior from '../../../State/Card/ModifierBehavior/AlgaeModifierBehavior';
import CrabCardBehavior from '../../../State/Card/CardBehavior/CrabCardBehavior';
import BaseCardHandler from '../../../System/Card/Handler/BaseCardHandler';
import ValueCardHandler from '../../../System/Card/Handler/ValueCardHandler';
import TornadoCard from './TornadoCard';
import TornadoCardBehavior from '../../../State/Card/CardBehavior/TornadoCardBehavior';
import FogModifier from './Modifier/Fog';
import FogModifierBehavior from '../../../State/Card/ModifierBehavior/FogModifierBehavior';
import JokerCardBehavior from '../../../State/Card/CardBehavior/JokerCardBehavior';
import JokerCard from './JokerCard';
import { CardType } from './CardType';
import { CardModifierType } from './CardModifierType';
import GoldCard from './GoldCard';
import GoldCardBehavior from '../../../State/Card/CardBehavior/GoldCardBehavior';
import GoldCardHandler from '../../../System/Card/Handler/GoldCardHandler';

type tModifierType = {
    [cardModifierType in CardModifierType]: {
        prototype: typeof CardModifier;
        behavior: typeof BaseModifierBehavior;
    };
};

export const ModifierTypeMap: tModifierType = {
    [CardModifierType.bomb]: {
        prototype: BombModifier,
        behavior: BombModifierBehavior,
    },
    [CardModifierType.rising]: {
        prototype: RisingModifier,
        behavior: RisingModifierBehavior,
    },
    [CardModifierType.lowering]: {
        prototype: LoweringModifier,
        behavior: LoweringModifierBehavior,
    },
    [CardModifierType.ice]: {
        prototype: IceModifier,
        behavior: IceModifierBehavior,
    },
    [CardModifierType.water]: {
        prototype: WaterModifier,
        behavior: WaterModifierBehavior,
    },
    [CardModifierType.algae]: {
        prototype: AlgaeModifier,
        behavior: AlgaeModifierBehavior,
    },
    [CardModifierType.fog]: {
        prototype: FogModifier,
        behavior: FogModifierBehavior,
    },
};

type tCardType = {
    [cardType in CardType]: {
        prototype: typeof BaseCard;
        handler: typeof BaseCardHandler;
        behavior: typeof BaseCardBehavior;
    };
};

export const CardTypeMap: tCardType = {
    [CardType.value]: {
        prototype: ValueCard,
        handler: ValueCardHandler,
        behavior: ValueCardBehavior,
    },
    [CardType.boom]: {
        prototype: BoomCard,
        handler: BaseCardHandler,
        behavior: BoomCardBehavior,
    },
    [CardType.zap]: {
        prototype: ZapCard,
        handler: BaseCardHandler,
        behavior: ZapCardBehavior,
    },
    [CardType.lock]: {
        prototype: LockCard,
        handler: BaseCardHandler,
        behavior: LockCardBehavior,
    },
    [CardType.key]: {
        prototype: KeyCard,
        handler: BaseCardHandler,
        behavior: KeyCardBehavior,
    },
    [CardType.plus_three]: {
        prototype: PlusThreeCard,
        handler: BaseCardHandler,
        behavior: PlusThreeCardBehavior,
    },
    [CardType.anchor]: {
        prototype: AnchorCard,
        handler: BaseCardHandler,
        behavior: AnchorCardBehavior,
    },
    [CardType.crab]: {
        prototype: CrabCard,
        handler: BaseCardHandler,
        behavior: CrabCardBehavior,
    },
    [CardType.tornado]: {
        prototype: TornadoCard,
        handler: BaseCardHandler,
        behavior: TornadoCardBehavior,
    },
    [CardType.joker]: {
        prototype: JokerCard,
        handler: BaseCardHandler,
        behavior: JokerCardBehavior,
    },
    [CardType.gold]: {
        prototype: GoldCard,
        handler: GoldCardHandler,
        behavior: GoldCardBehavior,
    },
};

/*
// Conditional types...
export type CardData = (
    | {
          type: 'boom' | 'zap' | 'lock' | 'key' | 'plus_three';
      }
    | {
          type: 'value';
          random: true;
      }
    | {
          type: 'value';
          value: number;
      }) & {
    x: number;
    y: number;
    depth: number;
    angle: number;
    modifiers: CardModifierData[];
    faceUp: boolean;
    id: string;
    sequence: number;
};
*/
